import { EyeResultsTable } from '../../ui';

// Contrast results table (Figma session/14 middle): logMAR | Right Eye | Left Eye | Binocular.
const CSTableResults = ({ results }) => (
  <EyeResultsTable
    columns={['logMAR', 'Right Eye', 'Left Eye', 'Binocular']}
    gap={4}
    data-testid='cs-results-table'
    rows={results.map((result) => {
      const { logmarTested, leftEye, rightEye, bothEyes } = result;
      return { tone: 'plain', cells: [logmarTested, rightEye?.toFixed(2) || '-', leftEye?.toFixed(2) || '-', bothEyes?.toFixed(2) || '-'] };
    })}
  />
);

export default CSTableResults;
